<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">Sincronização</h4>

          <!-- <p class="card-category">Here is a subtitle for this table</p> -->
        </div>
        <!-- <div class="x-page-links">
          <el-input
            v-model="search"
            prefix-icon="el-icon-search"
            style="width: 250px"
            placeholder="Digite para pesquisar"/>
        </div> -->
        <div class="table-responsive table-full-width">
          <el-table
              :data="tableData()"
              v-loading="loading"
              @sort-change="sorting"
              style="width: 100%">
              <el-table-column type="expand">
              <template slot-scope="props">
                <p>
                  <span class="expandrow">Atualizado: </span>{{ props.row.updated }}
                  <p></p>
                  <span class="expandrow">Solicitação: </span>{{ props.row.dh_solicitacao }}
                  <p></p>
                  <span class="expandrow">Envio: </span>{{ props.row.dh_envio }}
                  <p></p>
                  <span class="expandrow">Confirmação: </span>{{ props.row.dh_confirmacao }}
                  <p></p>
                  <span class="expandrow" v-if="props.row.error">Erros: </span>{{ props.row.error }}
                </p>
                <template>
                  <json-view v-if="props.row.sent_data" :data="props.row.sent_data" :maxDepth="0" rootKey="Payload" />
                </template>
              </template>
              </el-table-column>
              <el-table-column
              label="VM"
              sortable="custom"
              prop="vm.location">
              </el-table-column>
              <el-table-column
              label="Status"
              sortable="custom"
              prop="status">
              </el-table-column>
              <el-table-column
              label="Tipo de atualização"
              sortable="custom"
              prop="update_type">
              </el-table-column>
              <el-table-column
              label="Criado"
              sortable="custom"
              prop="created">
              </el-table-column>
          </el-table>
          <p class="x-page-links">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-sizes="[10, 15, 20,25]"
              :page-size="100"
              layout="sizes, prev, pager, next,total"
              :total="totalResults">
            </el-pagination>
          </p>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Tooltip, Loading, Pagination, } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tooltip.name]: Tooltip,
    [Pagination.name]: Pagination,
  },
  data() {
    return {
      companyList: [],
      sync: [],
      search: '',
      loading: true,
      machineList: [],
      pageSize: 10,
      page: 1,
      sord: '',
      pesquisa: '',
      totalResults: 30,
    };
  },
  computed: {
  },
  mounted() {
    const ciaID = localStorage.getItem('smartmachCiaID')
    if (ciaID) {
      this.getData(ciaID)
    } else {
      this.getData()
    }
    this.getListCompany()
    console.log('store', this.$store.state)
  },
  methods: {
    handleSizeChange(val) {
      this.loading = true
      this.pageSize = val
      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    handleCurrentChange(val) {
      this.loading = true
      this.page = val
      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    sorting(x) {
      this.loading = true
      var sinal
      console.log('x',x)
      if (x.order != null) {
        if (x.order === 'descending') {
          sinal = '-'
        } else {
          sinal = ''
        }
        if (x.prop === 'vm.location') {
          x.prop = 'vm'
        }
        this.sord = sinal + x.prop
      } else {
        this.sord = ''
      }
      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    getData (ciaID) {
      if (ciaID) {
        ciaID = ciaID
      } else {
        ciaID = ''
      }
      this.loading = true

      this.$store.dispatch("machines/listSort",{sort: '?company=' + ciaID}).then(resp => {
        this.machineList = resp
        this.$store.dispatch("lockers/listSort",{sort: '?company=' + ciaID}).then(data =>{
          for (let index = 0; index < data.length; index++) {
            this.machineList.push(data[index])
          }
          this.$store.dispatch("sync/listSort",{sort: '?page_size=' + this.pageSize
                + '&page=' + this.page + '&ordering=' + this.sord
                + '&vm__company='  + ciaID + this.pesquisa}).then(()=>{
            this.totalResults = this.$store.state.sync.page.count
            this.tableData()
          }).catch(err => console.log(err));

        })
      })
    },
    getListCompany () {
      this.$store.dispatch("company/list")
    },
    tableData() {
      this.sync = this.$store.state.sync.syncs
      const machines =  this.machineList
      const populated = this.sync.map(v =>{
        let vm, updated, created, status, update_type
        if (v.vm) {
          vm = machines.find(e => e.id == v.vm);
        }
        if (v.status) {
          if (v.status === 'Q') {
            status = 'Na fila'
          }
          if (v.status === 'A') {
            status = 'VM confirmou recebimento'
          }
          if (v.status === 'C') {
            status = 'Cancelado'
          }
          if (v.status === 'S') {
            status = 'Enviado para VM'
          }
          if (v.status === 'R') {
            status = 'Tentando enviar novamente'
          }
          if (v.status === 'G') {
            status = 'VM realizou a solicitação'
          }
          if (v.status === 'E') {
            status = 'Erro'
          }
          if (v.status === 'X') {
            status = 'Expirado'
          }
        }
        if (v.update_type) {
          if (v.update_type === 'P') {
            update_type = 'Produto'
          }
          if (v.update_type === 'S') {
            update_type = 'Estoque'
          }
          if (v.update_type === 'C') {
            update_type = 'Configurações'
          }
          if (v.update_type === 'I') {
            update_type = 'Inventario'
          }
        }
        if (v.updated) {
          const d = new Date(v.updated);
          updated = d.toLocaleString("pt-BR");
        }
        if (v.created) {
          const h = new Date(v.created);
          created = h.toLocaleString("pt-BR");
        }
        return { ...v, vm, updated, created, status, update_type };
      })
      this.loading = false
      return populated
    },
    permission (permissao) {
      var x = this.$store.state.general.permission.permissoes_do_usuario.filter(el => {
        if (el == permissao) {
          return true
        } 
      })
      if (x.length > 0) {
        return true
      }
    },
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
.card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
}
span.expandrow {
  font-weight: bold;
}
.x-page-links {
  margin-top: 15px;
  text-align: center;
}
.x-page-links span {
  cursor: pointer;
  margin: 0 10px;
}
.el-pagination__total {
    float: right;
    text-align: end;
    font-weight: 400;
    color: #606266;
}
</style>
